import { connect } from 'react-redux'
import DownloadEverything from './component'
import { getDownloadEverythingText, increaseCounter } from '../../../../data'
import { actions, selectors } from '../../../../imports'

function mapStateToProps(state) {
    return {
        label: getDownloadEverythingText(state),
        value: selectors.getDownloadEverything(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        save: (downloadEverything) => {
            dispatch(actions.setDownloadEverything(downloadEverything))
        },
        showMessage: () => {
            dispatch(increaseCounter())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadEverything)



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/DownloadEverything/index.js